import {Component, Input} from '@angular/core';
import {NgIf} from "@angular/common";
import {Vehicle} from "../../../models/common-data-types";

@Component({
  selector: 'app-vehicle-list-card',
  standalone: true,
    imports: [
        NgIf
    ],
  templateUrl: './vehicle-list-card.component.html',
  styleUrl: './vehicle-list-card.component.scss'
})
export class VehicleListCardComponent {

    @Input() vehicle!: Vehicle

}
